<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showProviderRate") }}</h4>
    </div>
    <div class="col-12 text-end mb-3">
      <v-btn @click="$router.go(-1)" style="color: #f47e2a">
        <i class="fas fa-backward"></i>
        {{ $t("BUTTONS.back") }}
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: User Data Section -->
          <div class="col-12 mb-3">
            <div class="section_header">
              <i class="fas fa-user"></i>
              <h5 class="section_title">{{ $t("TITLES.userData") }}</h5>
            </div>
          </div>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.client-name')"
            v-model.trim="data.user_name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.userMobile')"
            v-model.trim="data.user_mobile"
            disabled
          />
          <!-- End:: User Data Section -->

          <!-- Start:: Provider Data Section -->
          <div class="col-12 mb-3 mt-4">
            <div class="section_header">
              <i class="fas fa-store"></i>
              <h5 class="section_title">{{ $t("TITLES.providerData") }}</h5>
            </div>
          </div>

          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider_name"
            disabled
          />
          <!-- End:: Provider Data Section -->

          <!-- Start:: Rating Data Section -->
          <div class="col-12 mb-3 mt-4">
            <div class="section_header">
              <i class="fas fa-star"></i>
              <h5 class="section_title">{{ $t("TITLES.ratingData") }}</h5>
            </div>
          </div>

          <div class="col-md-4">
            <!-- <label class="field_label">{{
              $t("PLACEHOLDERS.rating_stars")
            }}</label> -->
            <div style="pointer-events: none">
              <base-rate-input :value="data.rate" size="28" :readonly="true" />
            </div>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderNumber')"
            v-model.trim="data.order_id"
            disabled
          />

          <base-input
            v-if="data.message"
            col="12"
            type="textarea"
            :placeholder="$t('TABLES.ProviderRates.comment')"
            v-model.trim="data.message"
            disabled
            :rows="5"
          />

          <div v-else class="col-12">
            <div class="no_comment_message">
              <i class="fas fa-info-circle"></i>
              <span
                >{{ $t("TABLES.noData") }} -
                {{ $t("TABLES.ProviderRates.comment") }}</span
              >
            </div>
          </div>
          <!-- End:: Rating Data Section -->

          <!-- Start:: Action Buttons -->
          <!-- <div class="col-12 mt-4">
            <div class="action_buttons_wrapper">
              <button
                v-if="!data.is_published"
                class="success_btn"
                type="button"
                @click="publishRating"
                :disabled="isWaitingRequest"
              >
                <i class="fal fa-check-circle"></i>
                {{ $t("BUTTONS.publishRating") }}
              </button>

              <div v-else class="published_badge">
                <i class="fas fa-check-circle"></i>
                {{ $t("STATUS.published") }}
              </div>

              <button
                class="danger_btn"
                type="button"
                @click="showDeleteDialog"
                :disabled="isWaitingRequest"
              >
                <i class="fal fa-trash-alt"></i>
                {{ $t("BUTTONS.delete") }}
              </button>
            </div>
          </div> -->
          <!-- End:: Action Buttons -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Delete Confirmation Dialog -->
    <v-dialog v-model="dialogDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("TITLES.DeleteProviderRate") }}
        </v-card-title>
        <v-card-text class="text-center">
          {{ $t("MESSAGES.deleteRatingConfirmation") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="modal_confirm_btn"
            @click="confirmDeleteRating"
            :disabled="isWaitingRequest"
          >
            {{ $t("BUTTONS.yes") }}
          </v-btn>
          <v-btn
            class="modal_cancel_btn"
            @click="dialogDelete = false"
            :disabled="isWaitingRequest"
          >
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Delete Confirmation Dialog -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShowProviderRate",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Dialog Control Data
      dialogDelete: false,
      // End:: Dialog Control Data

      // Start:: Data Collection To Send
      data: {
        user_name: null,
        user_mobile: null,
        provider_name: null,
        rate: null,
        message: null,
        created_at: null,
        order_serial: null,
        order_id: null,
        is_published: false,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Show Rate Data
    async showRate() {
      this.isWaitingRequest = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providerRates/${this.$route.params?.id}`,
        });

        // Handle new response structure: res.data.data.ProviderRate
        const rateData =
          res.data.data?.ProviderRate ||
          res.data.data?.data ||
          res.data.data ||
          res.data;

        this.data.user_name = rateData.user?.name || "-";
        this.data.user_mobile = rateData.user?.mobile || "-";
        this.data.provider_name = rateData.provider?.name || "-";
        this.data.rate = rateData.rate;
        this.data.message = rateData.message || null;
        this.data.order_id = rateData?.order_id;
        this.data.created_at = rateData.created_at;
        this.data.order_serial = rateData.order?.order_id || "-";
        this.data.is_published =
          rateData.is_published || rateData.status === "published" || false;

        this.isWaitingRequest = false;
      } catch (error) {
        this.isWaitingRequest = false;
        console.log(error?.response?.data?.message);
        this.$message.error(
          error?.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Show Rate Data

    // Start:: Validate Form Inputs
    validateFormInputs() {
      // This form is read-only, no validation needed
    },
    // End:: Validate Form Inputs

    // Start:: Publish Rating
    async publishRating() {
      this.isWaitingRequest = true;
      try {
        await this.$axios({
          method: "POST",
          url: `providerRates/${this.$route.params?.id}/publish`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.ratingPublishedSuccessfully"));
        this.data.is_published = true;
        // Optionally redirect back to list
        // this.$router.push({ path: "/provider-rates/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error?.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Publish Rating

    // Start:: Delete Rating
    showDeleteDialog() {
      this.dialogDelete = true;
    },
    async confirmDeleteRating() {
      this.isWaitingRequest = true;
      try {
        await this.$axios({
          method: "DELETE",
          url: `providerRates/${this.$route.params?.id}`,
        });
        this.dialogDelete = false;
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        // Redirect back to list
        this.$router.push({ path: "/provider-rates/all" });
      } catch (error) {
        this.dialogDelete = false;
        this.isWaitingRequest = false;
        this.$message.error(
          error?.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Delete Rating
  },

  created() {
    this.showRate();
  },
};
</script>

<style scoped>
.section_header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.section_header i {
  color: var(--main_theme_clr);
  font-size: 20px;
}

.section_title {
  color: var(--main_theme_clr);
  font-weight: bold;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--main_theme_clr);
  flex: 1;
}

.field_label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.no_comment_message {
  background: #f8f9fa;
  border: 1px dashed #dee2e6;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}

.no_comment_message i {
  margin-right: 8px;
  font-size: 18px;
}

.action_buttons_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.success_btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
  color: white !important;
  padding: 12px 30px;
  font-weight: bold;
  border-radius: 8px;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
}

.success_btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1aa87d 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.danger_btn {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
  color: white !important;
  padding: 12px 30px;
  font-weight: bold;
  border-radius: 8px;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);
}

.danger_btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

.success_btn:disabled,
.danger_btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.published_badge {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 12px 30px;
  font-weight: bold;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
}

.published_badge i {
  font-size: 18px;
}

/* RTL Support */
[dir="rtl"] .no_comment_message i {
  margin-right: 0;
  margin-left: 8px;
}

[dir="rtl"] .section_header {
  flex-direction: row-reverse;
}
</style>
